import EnvUtil from '../util/EnvUtil'
import { gsap, Cubic } from 'gsap/all'

class VideoPlayer
{
  // ---------------------------------------------------------------------------------------------------------
	// --	GlobalNav
	// ---------------------------------------------------------------------------------------------------------

  constructor(_g_movie_script){
    if (!_g_movie_script) return false

    // 設定値
    this.isOpen = false // 開いてるときtrue
    this.isAppend = false // 動画が配置されているか？
    this.embedTag = _g_movie_script
    this.scriptTag = $(this.embedTag)
    this.type = (this.embedTag.indexOf("<iframe") > -1) ? 'iframe' : 'script'

    this.setting = {
      playerSize: {
        w: 160,
        h: 90
      }
    }

    // Ulizaプレイヤーの設定を取る
    const _matchWidth = this.embedTag.match(/&amp;u_base_pw=(\d+)/)
    const _matchHeight = this.embedTag.match(/&amp;u_base_ph=(\d+)/)
    if (_matchWidth && _matchHeight)
    {
      this.setting.playerSize.w = _matchWidth[1]
      this.setting.playerSize.h = _matchHeight[1]
    }

    this.init()
  }

  init() {
    this.el = $('#video-player')
    this.cover = this.el.find('.video-player__cover')
    this.movie = this.el.find('.video-player__wrap')

    // 開くボタンDOM
    this.btnPlay = document.getElementById('detail-mv')
    this.btnPlay.addEventListener('click', this.open.bind(this))

    // 閉じるボタンDOM
    this.btnClose = this.el.find('.video-player__btnClose')
    this.btnClose.on('click', this.close.bind(this))

    // ウィンドウロードで動画を読み込み
    this.isAppend = true
    window.addEventListener('resize', this.resize.bind(this))
    this.resize()
  }

  start() {
    // 動画挿入
    this.movie.append(this.embedTag)


    /*
    console.log(this.embedTag)
    console.log($(this.embedTag));
    const script=document.createElement('script')
    script.src = 'https://player-api.p.uliza.jp/v1/playlists/default-player/vvoice/admin?name=20210915_test';
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('charset', 'utf-8')
    script.setAttribute('defer', true)
    script.innerText = "//{\"playlist\":{\"playlistType\":\"right_normal\",\"repeatType\":\"none\"}}"
    this.movie[0].appendChild(script)
    */
  }

  open(e)
  {
    e.preventDefault()

    if (this.isOpen) return
    this.isOpen = true
    if (!this.isAppend && this.type == 'iframe') this.movie.append(this.embedTag)

    // 強制リサイズ
    const evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0)
    window.dispatchEvent(evt)
    this.resize()

    // 動画モーダル表示
    this.el[0].classList.add('video-player--show')
    gsap.killTweensOf([this.cover, this.movie])
    gsap.fromTo(this.cover,
      {
        opacity: 0
      },
      {
        duration: 0.7,
        opacity: 1,
        ease: Cubic.easeInOut
      }
    )
    gsap.fromTo(this.movie,
      {
        opacity: 0
      },
      {
        delay: 0.1,
        duration: 0.7,
        opacity: 1,
        ease: Cubic.easeInOut
      }
    )
  }

  close(e)
  {
    e.preventDefault()

    if (!this.isOpen) return

    gsap.killTweensOf([this.cover, this.movie])
    gsap.to(this.cover,
      {
        delay: 0.1,
        duration: 0.7,
        opacity: 0,
        ease: Cubic.easeOut,
        onComplete: this.closeComp.bind(this)
      }
    )
    gsap.to(this.movie,
      {
        duration: 0.7,
        opacity: 0,
        ease: Cubic.easeOut
      }
    )
  }

  closeComp() {
    this.isOpen = false
    this.el[0].classList.remove('video-player--show')

    if (this.type === 'iframe')
    {
      // iframeのvideoはコントロールできないので削除
      this.movie.find('iframe').remove()
      this.isAppend = false;
    }
    else
    {
      // 一時停止
      this.movie.find('video').each(function(i, el) {
        el.pause()
      });
    }
  }

  resize() {
    // 動画のリサイズ
    const defW = window.innerWidth
    const defH = window.innerHeight
    const winW = defW * 0.90
    const winH = (defH * 0.90) > 200 ? defH * 0.90 : 200

    //var scale = Math.max(160 / windowW, 90 / windowH)
    const scale = Math.max(this.setting.playerSize.w / winW, this.setting.playerSize.h / winH)
    const iframeW = this.setting.playerSize.w / scale
    const iframeH = this.setting.playerSize.h / scale
    const iframeX = (defW - iframeW) / 2
    const iframeY = (defH - iframeH) / 2

    const style = this.movie[0].style
    style.position = 'absolute'
    style.left = `${iframeX}px`
    style.top = `${iframeY}px`
    style.width = `${iframeW}px`
    style.height = `${iframeH}px`
  }

	// ---------------------------------------------------------------------------------------------------------
}

export default VideoPlayer